import { SpecialFreightIdView } from '../../../../models';

export class ShipmentSpecialFreightNotificationsLoad {
  public static readonly type = '[ShipmentSpecialFreightNotifications] Load Notifications';
  constructor(public payload: SpecialFreightIdView) {}
}

export class ShipmentSpecialFreightNotificationsSetInitialState {
  public static readonly type = '[ShipmentSpecialFreightNotifications] Set Initial State';
}
